import { Redirect, Route, Switch } from 'react-router-dom';

import { userRoles } from 'lib/src/shared/enums/dropdownEnums';

import AdminUsersRoutes from './AdminUsersRoutes';
import SuperAdminUsersRoutes from './SuperAdminUsersRoutes';
import AuthRoutes from './AuthRoutes';
import SubRouter from './SubRouter';
import UsersRoutes from './UsersRoutes';
import Dashboard from '@pages/dashboard/Dashboard';
import AssessmentsRoutes from './AssessmentsRoutes';
import ChallengeTagsRoutes from './ChallengeTagsRoutes';
import ChallengeGroupsRoutes from './ChallengeGroupsRoutes';
import ChallengesRoutes from './ChallengesRoutes';
import ContactUsMessagesRoutes from './ContactUsMessagesRoutes';
import PageNotFound from '@pages/pageNotFound/PageNotFound';
import ChallengeCalendar from '@pages/challengeCalendar/ChallengeCalendar';

const Routes: React.FC = () => (
    <Switch>
        <SubRouter exact path="/" auth>
            <Dashboard />
        </SubRouter>
        <SubRouter path="/assessments" auth requiredRole={userRoles.assessor}>
            <AssessmentsRoutes />
        </SubRouter>
        <SubRouter path="/challenge-groups" auth requiredRole={userRoles.challengeGroups}>
            <ChallengeGroupsRoutes />
        </SubRouter>
        <SubRouter path="/challenges" auth requiredRole={userRoles.superAdmin}>
            <ChallengesRoutes />
        </SubRouter>
        <SubRouter path="/tags" auth requiredRole={userRoles.challengeTags}>
            <ChallengeTagsRoutes />
        </SubRouter>
        <SubRouter path="/calendar" auth requiredRole={userRoles.calendar}>
            <ChallengeCalendar />
        </SubRouter>
        <SubRouter path="/auth">
            <AuthRoutes />
        </SubRouter>
        <SubRouter path="/users" auth requiredRole={userRoles.users}>
            <UsersRoutes />
        </SubRouter>
        <SubRouter path="/admins" auth requiredRole={userRoles.admins}>
            <AdminUsersRoutes />
        </SubRouter>
        <SubRouter path="/superadmins" auth requiredRole={userRoles.superAdmin}>
            <SuperAdminUsersRoutes />
        </SubRouter>
        <SubRouter path="/contact-us-messages" auth requiredRole={userRoles.contactUsMessages}>
            <ContactUsMessagesRoutes />
        </SubRouter>
        <Route exact path="/page-not-found">
            <PageNotFound />
        </Route>
        <Redirect to="/page-not-found" />
    </Switch>
);

export default Routes;
